import swe from "./dictionaries/swe.js";

export default(text) => {
  return swe[text] ? swe[text] : text;
};
